/**
 * tRPC Client
 *
 * Vanilla tRPC client for Studio.
 * Types are automatically inferred from the backend AppRouter.
 */

import { createTRPCClient, httpBatchLink } from '@trpc/client'

// Import type only - requires server to be built first
import type { AppRouter } from '../../../server/src/trpc/routers/_app.js'

const API_URL = import.meta.env.VITE_API_URL || 'https://api.fuguelab.com'

export const trpc = createTRPCClient<AppRouter>({
  links: [
    httpBatchLink({
      url: `${API_URL}/trpc`,
    }),
  ],
})
